import { useMutation } from 'react-query';
import request from '../helpers/request';

const addToAcceptanceCalendar = async (body) => {
  const { requestId, date, intervalId } = body;

  const data = await request.post(
    '/Request/acceptance_datetime',
    {
      requestId,
      date,
      intervalId,
    },
    'При добавлении заявки в календарь приемки произошла ошибка',
    'Error',
    'К сожалению, время уже заняли. Выберите другую дату или период'
  );

  return data;
};

const useAddToAcceptanceCalendar = (options) => {
  return useMutation(({ values }) => addToAcceptanceCalendar(values), options);
};

export default useAddToAcceptanceCalendar;
